var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    xmlns: "https://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-7.5%",
    y: "-8.5%",
    width: "114.7%",
    height: "118.9%",
    filterUnits: "objectBoundingBox",
    id: "lighting-icon_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.206457605 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lighting-icon_svg__a)",
    transform: "translate(-13 -46)",
    fill: "#9D3DE8",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.083 62h-2.05l2.262-3.619a.25.25 0 00-.212-.381h-4a.25.25 0 00-.242.19l-1.5 6a.25.25 0 00.242.31h1.673l-1.414 5.184a.25.25 0 00.138.293.255.255 0 00.311-.089l5-7.5a.25.25 0 00-.208-.388z"
  }))));
}
export default SvgLightingIcon;